import React from "react";
import api from "../../utility/api/api.js";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from "reactstrap";
import {
  Route,
  BrowserRouter,
  NavLink,
  Switch,
  browserHistory,
  withRouter,
} from "react-router-dom";
import createHistory from "history/createBrowserHistory";
import { assignedJobsAction, cancelReasonAction } from "../../actions/index";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
class CancelJob extends React.Component {
  constructor(props) {
    super(props);
    this.state = { modal: false };
    // this.masterData = JSON.parse(localStorage.getItem("getMasterData"));
    this.toggle = this.toggle.bind(this);
    const history = createHistory();
    const unlisten = history.listen((location, action) => {
      if (this.state.modal) {
        this.setState({ modal: false });
      }
    });
  }
  toggle(data, e) {
    if (data === "Reject") {
      if (document.querySelector("input[name='cancel_reason']:checked")) {
        let value = document.querySelector(
          "input[name='cancel_reason']:checked"
        ).value;
        api.cancelJob(this.props.trip_id, value);
      } else {
        this.setState({ error: "Please Select the field" });
        e.preventDefault();
        return;
      }
    }
    this.setState({
      modal: !this.state.modal,
      error: "",
    });
  }

  render() {
    if (this.props && this.props.cancelResons) {
      return (
        <div>
          <BrowserRouter>
            <div>
              <NavLink to="/assigned/canceljob">
                <button
                  className="spn-jobs-decisionbutton btn spn-jobs-decisionbutton-cancel"
                  onClick={this.toggle}
                >
                  Reject
                </button>
              </NavLink>

              <Switch>
                <Route path="/assigned/canceljob">
                  <Modal
                    isOpen={this.state.modal}
                    backdrop={"static"}
                    keyboard={false}
                    fade={false}
                    toggle={this.toggle}
                    className={this.props.className}
                  >
                    <ModalHeader className="justify-content-center py-2 alert-secondary">
                      {this.props.label}
                    </ModalHeader>
                    <ModalBody>
                      <div className="select-reason-title">SELECT REASON</div>
                      {this.props &&
                        this.props.cancelResons &&
                        this.props.cancelResons[0].data &&
                        this.props.cancelResons[0].data.reasons.map(
                          (obj, key) => (
                            <div key={key}>
                              <div>
                                <input
                                  className="with-gap custom-check"
                                  onChange={(e) => this.setState({ error: "" })}
                                  value={obj.reason}
                                  id={`cancel_${key}`}
                                  name="cancel_reason"
                                  type="radio"
                                />
                                <Label htmlFor={`cancel_${key}`}>{obj.reason}</Label>
                              </div>
                            </div>
                          )
                        )}
                      <div className="text-danger">{this.state.error}</div>
                    </ModalBody>
                    <ModalFooter className="p-0 border-0">
                      <span className="col-6 text-center">
                        <NavLink to="/assigned">
                          <button
                            className="btn bg-white m-0 py-2"
                            onClick={this.toggle}
                          >
                            Cancel
                          </button>
                        </NavLink>
                      </span>
                      <span className="col-6 text-center">
                        <NavLink
                          className="btn m-0 py-2"
                          exact
                          to="/completed"
                          onClick={(e) => this.toggle(this.props.label, e)}
                        >
                          OK, Done
                        </NavLink>
                      </span>{" "}
                    </ModalFooter>
                  </Modal>
                </Route>
              </Switch>
            </div>
          </BrowserRouter>
        </div>
      );
    } else {
      return (
        <div>
          <Button onClick={this.toggle}>{this.props.label}</Button>
        </div>
      );
    }
  }
}
function mapStateToProps(state) {
  console.log("holdDetails", state);
  return {
    cancelResons: state.getCancelReasons,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      assignedJobsAction: assignedJobsAction,
      cancelReasonAction: cancelReasonAction,
    },
    dispatch
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(CancelJob);



// WEBPACK FOOTER //
// ./src/components/Assigned/CancelJob.js